require('./angular-cookies');
module.exports = 'ngCookies';



// WEBPACK FOOTER //
// ./~/angular-cookies/index.js